import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingCart } from "@mui/icons-material";
import { useProductContext } from "../../../context/ProductContext";
import { useNotification } from "../../../context/NotificationContext";
import { BranchProduct } from "../../../types";

interface ExtraSmallProductCardProps {
  product: BranchProduct;
  getCardColors: string;
  getBadgeColor: () => string;
  t: (key: string) => string;
  handleWhatsAppPurchase: (qty: number) => void;
}

const ExtraSmallProductCard: React.FC<ExtraSmallProductCardProps> = ({
  product,
  getCardColors,
  getBadgeColor,
  t,
  handleWhatsAppPurchase,
}) => {
  const navigate = useNavigate();
  const { addToCart } = useProductContext();
  const { notify } = useNotification();
  const [isHovered, setIsHovered] = useState(false);

  const handleAdd = (qty: number) => {
    for (let i = 0; i < qty; i++) addToCart(product.product.id);
    notify("success", t("productCard.addedToCart", ));
  };

  const badge = product.product.badge;
  const images = product.product.images || [];

  return (
    <div
        data-product-id={product.id}
        className="bg-white rounded-xl shadow-sm hover:shadow transition-all duration-300 overflow-hidden"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Image */}
        <div
          className="relative aspect-square cursor-pointer"
          onClick={() => navigate(`/product/${product.product.id}`)}
        >
          <img
            src={images[0]?.image || "/api/placeholder/200/200"}
            alt={product.product.name}
            className="w-full h-full object-cover"
          />

          {/* Badge - فقط لو مهم */}
          {badge === "sale" || badge === "new" ? (
            <span
              className={`absolute top-1 left-1 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${getBadgeColor()}`}
            >
              {badge === "sale" ? "خصم" : "جديد"}
            </span>
          ) : null}
        </div>

        {/* Content */}
        <div className="p-2">
          {/* Title - line clamp 2 */}
          <h3 className="font-medium text-gray-800 text-xs line-clamp-2 mb-1 min-h-[2rem]">
            {product.product.name}
          </h3>

          {/* Price */}
          <div className="flex items-center justify-between mb-1.5">
            <span className="text-sm font-bold text-primary">
              ج.م {product.price}
            </span>
            <span
              className={`text-[10px] px-1.5 py-0.5 rounded-full ${
                product.stock <= 3
                  ? "bg-yellow-100 text-yellow-700"
                  : "bg-green-100 text-green-700"
              }`}
            >
              {product.stock}
            </span>
          </div>

          {/* Add to Cart Button */}
          <button
            className={`w-full py-1.5 bg-gradient-to-r ${getCardColors} text-white text-xs font-medium rounded-lg hover:opacity-90 transition-all duration-300 flex items-center justify-center gap-1`}
            onClick={() => handleAdd(1)}
            disabled={!product.is_available}
          >
            <ShoppingCart className="w-3 h-3" />
            {product.is_available
              ? t("productCard.addToCart")
              : t("productCard.outOfStock")}
          </button>
        </div>
      </div>
  );
};

export default ExtraSmallProductCard;
